import { THttpService } from '@/services/HttpService';

import { TVoucherPurchaseInput } from './types';

type TResponse =
  | {
      status: number;
    }
  | undefined;

const formatSuccess = (response: TResponse) => {
  return response && response.status >= 200 && response.status < 300
    ? 'success'
    : 'error';
};

const formatError = () => {
  return 'error';
};

export const submitVoucherPurchase = async (
  api: THttpService,
  params: TVoucherPurchaseInput,
): Promise<string> => {
  const p_p_id = 'smilesmilespurchaseportlet_WAR_smilesmilesportlet';
  const p_p_lifecycle = '2';
  const p_p_state = 'normal';
  const p_p_mode = 'view';
  const p_p_resource_id = 'addToCheckout';
  const p_p_cacheability = 'cacheLevelPage';
  const p_p_col_id = '_118_INSTANCE_nDTRI6O6Dsdp__column-3';
  const p_p_col_count = '1';

  const path = `/group/guest/minha-conta/comprar-milhas?p_p_id=${p_p_id}&p_p_lifecycle=${p_p_lifecycle}&p_p_state=${p_p_state}&p_p_mode=${p_p_mode}&p_p_resource_id=${p_p_resource_id}&p_p_cacheability=${p_p_cacheability}&p_p_col_id=${p_p_col_id}&p_p_col_count=${p_p_col_count}`;

  const data = `_smilesmilespurchaseportlet_WAR_smilesmilesportlet_quantity=${params.milesQuantity}&_smilesmilespurchaseportlet_WAR_smilesmilesportlet_optionId=${params.optionId}&_smilesmilespurchaseportlet_WAR_smilesmilesportlet_operation=PURCHASE&_smilesmilespurchaseportlet_WAR_smilesmilesportlet_voucherNumber=${params.voucherNumber}`;

  try {
    const response = (await api.post(`${path}`, data)) as unknown as TResponse;
    return formatSuccess(response);
  } catch (error) {
    return formatError();
  }
};
